











































































import { Advertiser } from "@/interfaces/advertiser";
import { MessageBox } from "@/interfaces/messagebox";
import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    advertiser: {
      required: false,
      type: Object as PropType<Advertiser>
    },
    advertisement: {
      required: false,
      type: Object as PropType<Advertisement>
    },
    showAdvertisement: {
      required: false,
      default: true,
      type: Boolean
    },
    title: {
      type: String,
      default: "メッセージログ"
    }
  },
  methods: {
    async fetchMessageBoxes() {
      this.loading = true;
      const params: { [key: string]: string | number } = {};
      let hasAnyFilter = false;
      if (this.$props.advertiser && this.$props.advertiser.id) {
        params.client = this.$props.advertiser.id;
        hasAnyFilter = true;
      }
      if (this.$props.advertisement && this.$props.advertisement.id) {
        params.post = this.$props.advertisement.id;
        hasAnyFilter = true;
      }
      if (!hasAnyFilter) {
        console.log("spin wait");
        await new Promise(
          (resolve, reject) => setTimeout(resolve, 1000)
        );
        return;
      }
      params.page = this.page;
      params.itemsPerPage = this.perPage;
      params["order[" + this.sortField + "]"] = this.sortOrder;
      const res = await this.$store.dispatch("get", [
        "/api/adv/message_boxes",
        params
      ]);
      this.messageBoxes = res["hydra:member"];
      this.total = res["hydra:totalItems"];
      this.loading = false;
    },
    onPageChange(page: number) {
      this.page = page;
      this.fetchMessageBoxes();
    },
    onSort(field: string, order: string) {
      this.sortField = field;
      this.sortOrder = order;
      this.fetchMessageBoxes();
    }
  },
  mounted() {
    this.fetchMessageBoxes();
  },
  data() {
    return {
      messageBoxes: [] as MessageBox[],
      page: 1,
      perPage: 10,
      defaultSortOrder: "id",
      sortField: "id",
      sortOrder: "desc",
      total: NaN,
      loading: true
    };
  }
});
